<template>
  <div>
    <h1>“{{ webTitle }}”纠纷处理流程</h1>
    <p class="content">
      1.便捷的申诉通道：我司会采取必要的措施和申诉处理程序保障用户的合法权益，并在公司网站向用户作出说明，如出现纠纷，用户应出示与注册身份一致的有效身份，在核实后按照申诉处理。
      2.
      如若本平台用户之间发生纠纷且无法协商一致的，可向国家相关行政机关或司法机关寻求解决，包括但不限于向公安机关报案、申请仲裁或向人民法院提起诉讼等。{{company}}将会为实名注册用户提供必要的协助和支持，并根据有关行政机关和司法机关的要求承担一定的举证责任或采取必要措施。
      3.本平台用户之间发生纠纷的，也可向{{company}}的客服人员投诉并举证。用户需提供与其账号注册信息一致的个人有效身份证件、必要的国家行政或司法机关文件和其他边城游侠要求提供的相关证据。经{{company}}审核确认后，可以给予必要的协助和支持。
      4.用户与{{company}}之间纠纷处理方式，如本平台用户对{{company}}的服务有任何异议的，可以向{{company}}的客服人员投诉并举证。查证属实的，{{company}}将立即更正并按照现行法律规定给予用户必要的补偿。
      如本平台用户对{{company}}的服务有任何异议的，也可以向双方约定（具体参见《用户协议》）的{{company}}所在地人民法院提起诉讼。
      联系方式：{{ phone }} 邮箱：{{ mail }}
    </p>
  </div>
</template>
<script>
import { webTitle, phone, mail, company } from '../../utils'

export default {
  name: 'help',
  computed: {
    webTitle () {
      return webTitle()
    },
    phone () {
      return phone()
    },
    mail () {
      return mail()
    },
    company () {
      return company()
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding: 0 40px 0;
  white-space: pre-wrap;
  text-align: left;
}
</style>
